import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProfileApiService } from '../../../../projects/api/src/user/profile/profile-api.service';
import { NotifymethodModel } from '../../../../projects/api/src/notifymethod/notifymethod.model';
import {
  CompanyModel,
  ProfileActivity,
  UserInfo,
} from '../../../../projects/api/src/user/user.model';
import { UsersubscriptionModel } from '../../../../projects/api/src/usersubscription/usersubscription.model';
import { UsersubscriptionsApiService } from '../../../../projects/api/src/usersubscription/usersubscriptions-api.service';
import { AuthService } from '../../shared/services/auth.service';
import { UserService } from '../../shared/services/user.service';
import { UsergroupsApiService } from '../../../../projects/api/src/usergroup/usergroups-api.service';
import { UsergroupModel } from '../../../../projects/api/src/usergroup/usergroup.model';
import { BehaviorSubject } from 'rxjs';
import { UsernotificationsApiService } from '../../../../projects/api/src/usernotification/usernotifications-api.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ICONS_MAP } from '../../shared/constnts/icons-map';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
  public passwordEnterForm: FormGroup;
  public modalHeader = '';
  public companies: CompanyModel[];
  public currentCompany: CompanyModel;
  public profile: UserInfo;
  public usersubscriptions: UsersubscriptionModel[];
  public isLocal = true;
  public twofactorState$ = new BehaviorSubject('loading');
  public twofactor$ = new BehaviorSubject({
    totpEnabled: false,
    emailContact: null,
    smsContact: null,
  });
  public twofactor = { totpEnabled: false, emailContact: null, smsContact: null };
  public emailsContacts = [];
  public emailContact: NotifymethodModel | null = null;
  @ViewChild('modalDialogPasswordForm', { static: true }) modalDialogPasswordForm;
  public modalDialogTemplate;
  public showModalDialog = false;
  password = '';
  groups: UsergroupModel[] = [];

  activities: ProfileActivity[] = [];
  activeActivities: ProfileActivity[] = [];
  nonactiveActivities: ProfileActivity[] = [];

  events: any[] = [];

  protected readonly ICONS_MAP = ICONS_MAP;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private usersubscriptionsApi: UsersubscriptionsApiService,
    private usernotificationsApi: UsernotificationsApiService,
    private profileApi: ProfileApiService,
    private userService: UserService,
    private authService: AuthService,
    private usergroups: UsergroupsApiService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    const routeData = this.route.snapshot.data;
    if (routeData.profile) {
      this.profile = routeData.profile;
      if (this.profile.authService === 'ACTIVE_DIRECTORY') {
        this.isLocal = false;
      } else if (this.profile.authService === 'OAUTH2') {
        this.isLocal = false;
      } else {
        this.isLocal = true;
      }
    }

    if (routeData.companies) {
      this.companies = routeData.companies;
    }
    if (this.userService && this.userService.rawData) {
      this.currentCompany = this.userService.rawData.company;
    } else if (routeData.company) {
      this.currentCompany = routeData.company;
    }
    if (routeData.usersubscriptions) {
      this.usersubscriptions = routeData.usersubscriptions.filter(
        this.usersubscriptionsApi.isSubscrided
      );
      console.log('this.usersubscriptions', this.usersubscriptions);
    }
  }

  clickSubscription(e) {
    this.router.navigateByUrl(`/main/page/profilesubscription/list`);
  }

  hasSubscription(methods: NotifymethodModel[], name: string) {
    if (methods && methods.length) {
      return (methods.find((m) => m.methodname === name) || {}).subscribed;
    }
    return false;
  }

  toggleActivity(value) {
    if (value && this.activities.length === 0) {
      this.profileApi.getActivities().subscribe((items) => {
        this.activities = items;
        this.activeActivities = this.activities.filter((val) => val.endTime > Date.now());
        this.nonactiveActivities = this.activities.filter((val) => val.endTime <= Date.now());
        this.cdr.detectChanges();
      });
    }
  }

  toggleSafety(value) {
    if (value && this.groups.length === 0) {
      this.usergroups.getUserGroups(this.userService.rawData.id).subscribe((items) => {
        this.groups = items;
      });
    }
  }

  protected getIcon(name: string) {
    switch (name) {
      case 'EMAIL':
        return 'fas fa-envelope-square';
      case 'TELEGRAM':
        return 'fab fa-telegram';
      case 'SLACK':
        return 'fab fa-slack';
      case 'SMS':
        return 'fas fa-sms';
      case 'PUSH':
        return 'fab fa-pushed';
      default:
        return 'fas fa-envelope-square';
    }
  }
}
